<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Monthly Summary
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12 v-if="data2">
                        <vue-plotly disable-responsive show-export :data="data2" :layout="layout2" :options="options2"/>
                    </v-flex>
                    <v-flex v-for="plot in plotList" :key="'ms'+plot.id"  v-bind:class="[plot['flex-class'], 'xs12']" >
                        <cop-plot v-if="plot.type==='cop'" ref="plots"
                                  :variable-x="plot.config['variable-x']"
                                  :variable-y="plot.config['variable-y']"
                                  :facility_name="facility_name"
                                  :date-range="plot.config['range'] ? plot.config['range'] : dateRange"
                                  :layout-overrides="plot.config['layout-overrides']"
                                  :extra-vars="plot.config['extra-vars']"
                                  :type="plot.config['type']"
                                  :mode="plot.config['mode']"
                        ></cop-plot>
                        <multi-plot-chart ref="plots" v-if="plot.type==='multi-chart'"
                                          disable-responsive
                                          :date-range="plot.config['range'] ? plot.config['range'] : dateRange"
                                          :variable-x="plot.config['variable-x']"
                                          :variables-list="plot.config['variables-list']"
                                          :layout-overrides="plot.config['layout-overrides']"
                                          :type="plot.config['type']"
                        ></multi-plot-chart>
                    </v-flex>
                    <v-flex xs12>
                        <notifications dashboard-mode monthly-mode></notifications>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import {callAPI} from '@/helper'
    import VuePlotly from '@/components/VuePlotly'
    import moment from 'moment'
    import Notifications from "./Notifications";
    import MultiPlotChart from "../components/MultiPlotChart"
    import CopPlot from "../components/CopPlot";



    export default {
        name: 'TestMonthlySummary',
        components: {VuePlotly,Notifications,MultiPlotChart,CopPlot},
        computed: {
            facility_name() {
                return this.$store.state.pointsListStore.facility_name
            },
            savingPercentage () {
                if(this.totalSavingSum===0){
                    return 0;
                }
                return 100*this.totalSavingSum/(this.totalSavingSum+this.totalPowerSum);
            },
            plotList(){
                return [
                    {
                        'id': 6,
                        'type': 'multi-chart',
                        'config': {
                            'layout-overrides': {
                                xaxis: {
                                    title:"Outdoor air temperature (°C)",
                                },
                                yaxis: {
                                    title:'Cooling Load (kW)',
                                }
                            },
                            type: 'scatter',
                            'variables-list':this.chillers.map(equip=>{
                                return ({
                                    equipment_name: equip,
                                    facility_name: this.facility_name,
                                    mode: "markers",
                                    name: "Cooling_Load",
                                    variableX: "Outdoor_Air_Temperature"
                                })
                            }),

                        }
                    },
                    {
                        'id': 7,
                        'type': 'multi-chart',
                        'config': {
                            'layout-overrides': {
                                xaxis: {
                                    title: "Time "
                                },
                                yaxis: {title: 'Cooling Load (kW)'},
                                yaxis2: {
                                    title: 'Outdoor Temperature (°C)',
                                    overlaying: 'y',
                                    side: 'right'
                                },
                            },
                            type: 'scatter',
                            'variables-list':[
                                {
                                    equipment_name: "Weather",
                                    facility_name: this.facility_name,
                                    yaxis: 'y2',
                                    name: "Outdoor_Temperature",
                                },
                                ...this.chillers.map(equip=>{
                                return ({
                                    equipment_name: equip,
                                    facility_name: this.facility_name,
                                    name: "Cooling_Load",
                                })
                            })],

                        }
                    },
                    {
                        'id': 8,
                        'type': 'cop',
                        'config': {
                            'layout-overrides': {
                                "title":"Plant COP",
                                xaxis: {
                                    title: "Time "
                                },
                            },
                            'variable-x': 'timestamp',
                            'variable-y': 'COP',
                            'type': 'scatter',
                        }
                    },
                    {
                        'id': 11,
                        'type': 'multi-chart',
                        'config': {
                            'layout-overrides': {
                                xaxis: {
                                    title: "Time "
                                },
                                yaxis: {
                                    title: "Temperature (°C)"
                                }
                            },
                            'variables-list': [
                                {
                                    equipment_name: "Weather",
                                    facility_name: "SHT",
                                    name: "Outdoor_Temperature",
                                },
                                {
                                    equipment_name: "Chiller Header",
                                    facility_name: "SHT",
                                    name: "Main_Supply_Temp",
                                },
                                {
                                    equipment_name: "Chiller Header",
                                    facility_name: "SHT",
                                    name: "Main_Return_Temp",
                                },
                                {
                                    equipment_name: "Chiller Header",
                                    facility_name: "SHT",
                                    name: "CHW_Temp_Diff",
                                }
                            ],
                        }
                    },
                    {
                        'id': 12,
                        'type': 'multi-chart',
                        'config': {
                            'layout-overrides': {
                                title:"Flow Rate",
                                xaxis: {
                                    title: "Time "
                                },
                                yaxis: {
                                    title: "Flow Rate (L/s)"
                                }
                            },
                            'variables-list': [
                                {
                                    equipment_name: "Chiller Header",
                                    facility_name: "SHT",
                                    name: "Flow_Rate",
                                }

                            ],
                        }
                    },
                    ...this.chillers.map(equip=>{
                        return ({
                            'id': equip,
                            'type': 'multi-chart',
                            'config': {
                                'layout-overrides': {
                                    title:equip+' Performance',
                                    xaxis: {
                                        title: "Time "
                                    },
                                    yaxis: {
                                        title: "Temperature (°C)"
                                    },
                                    yaxis2: {
                                        title: 'COP',
                                        overlaying: 'y',
                                        side: 'right'
                                    },
                                },
                                'variables-list': [
                                    {
                                        equipment_name: equip,
                                        facility_name: this.facility_name,
                                        name: "Outdoor_Air_Temperature",
                                    },
                                    {
                                        equipment_name: equip,
                                        facility_name: this.facility_name,
                                        name: "CHWS_Temp",
                                    },
                                    {
                                        equipment_name: equip,
                                        facility_name: this.facility_name,
                                        name: "CHW_Temp_Diff",
                                    },
                                    {
                                        equipment_name: equip,
                                        facility_name: this.facility_name,
                                        yaxis: 'y2',
                                        name: "efficiency",
                                    }

                                ],
                            }
                        })
                    })
                ]
            }
        },
        data () {
            return {
                dateRange: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
                loading:true,
                data2:null,
                timeout:null,
                options2: {},
                layout2:{
                    title:"Energy consumption",
                    yaxis: {
                        title: 'Energy consumption (kWh)'
                    },
                    xaxis: {
                        title: 'Time (daily)'
                    }
                },


            }
        },
        methods:{
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout= setTimeout(() => callback(), wait);
            },
            refresh(){
                this.debounce(this.doRefresh,200);
            },
            doRefresh() {
                let me=this;
                me.loading=true;
                let promises=[];
                let timestamp=null;
                let chillers=[];
                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                    if(equip.equipment_type==='chiller'){
                        chillers.push(equip.equipment_name)
                        promises.push(callAPI('data/',
                            {
                                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                                'equipment_name': equip.equipment_name,
                                'agg': 'D',
                                'agg_op': 'sum',
                                'date_range':[me.dateRange.start, me.dateRange.end+" 23:59"],
                                'sensor_names': ['Comp_Power']
                            }
                        ))
                    } else if(equip.equipment_type==='pump'&&this.$store.state.pointsListStore.pointsList.facility_name!="CRP"){
                        promises.push(callAPI('data/',
                            {
                                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                                'equipment_name': equip.equipment_name,
                                'agg': 'D',
                                'agg_op': 'sum',
                                'date_range':[me.dateRange.start, me.dateRange.end+" 23:59"],
                                'sensor_names': ['KW']
                            }
                        ))
                    }
                }
                me.chillers=chillers;
                Promise.all(promises).then(function(reses) {
                    let secondChartData = [];
                    for (let res of reses) {
                        if(!timestamp){
                            timestamp=res.data.timestamp;
                        }
                        if (res.data['Comp_Power']) {
                            secondChartData.push({
                                x: timestamp,
                                y: res.data['Comp_Power'].map(i=>i/me.$store.state.pointsListStore.pointsList.sampling_freq),
                                name: JSON.parse(res.config.data)["equipment_name"],
                                hasOwnGraph:true,
                                stackgroup: 'one',
                                type: 'scatter',
                                mode: 'none'
                            });
                        } else if (res.data['KW']) {
                            secondChartData.push({
                                x: timestamp,
                                y: res.data['KW'].map(i=>i/me.$store.state.pointsListStore.pointsList.sampling_freq),
                                name: JSON.parse(res.config.data)["equipment_name"],
                                stackgroup: 'one',
                                type: 'scatter',
                                mode: 'none'
                            });
                        }
                    }
                    secondChartData.sort((a, b) => (a.name > b.name) ? 1 : -1)
                    me.data2=secondChartData;
                    me.loading=false;
                });

            }
        },
        mounted() {
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(maxDate){
                this.dateRange={
                    start:moment(maxDate).subtract(30, "days").format('YYYY-MM-DD'),
                    end: moment(maxDate).format('YYYY-MM-DD')
                }
            }
            this.refresh();
        },
        watch: {
            dateRange () {
                this.refresh()
            }
        }


    }
</script>
